module.exports = __webpack_public_path__ + "img/bitget.15567de9.png";